import { customFetch } from "./usersApi";

export const updateProfile = (data, userId) => {
  return customFetch.put(`/auth/update-profile/${userId}`, data);
};

export const changePassword = (data, userId) => {
  return customFetch.put(`/auth/change-password/${userId}`, data);
};

export const fetchDashboardCount = () => {
  return customFetch.get(`/count/dashboard`);
};

export const fetchUsers = (page) => {
  return customFetch.get(`/user/all/${page}/100`);
};

export const addEvent = (data) => {
  return customFetch.post(`/event/add`, data);
};

export const fetchEvents = (page) => {
  return customFetch.get(`/event/all/${page}/100`);
};

export const fetchEvent = (id) => {
  return customFetch.get(`/event/${id}`);
};

export const updateEvent = (id, data) => {
  return customFetch.put(`/event/${id}`, data);
};

export const deleteEvent = (id, data) => {
  return customFetch.post(`/event/delete/${id}`, data);
};

export const addAdvert = (data) => {
  return customFetch.post(`/advert/add`, data);
};

export const fetchAdverts = (page) => {
  return customFetch.get(`/advert/all/${page}/100`);
};

export const fetchAdvert = (id) => {
  return customFetch.get(`/advert/${id}`);
};

export const updateAdvert = (id, data) => {
  return customFetch.put(`/advert/${id}`, data);
};

export const deleteAdvert = (id, data) => {
  return customFetch.post(`/advert/delete/${id}`, data);
};

export const addInterview = (data) => {
  return customFetch.post(`/interview/add`, data);
};

export const fetchInterviews = (page) => {
  return customFetch.get(`/interview/all/${page}/100`);
};

export const fetchInterview = (id) => {
  return customFetch.get(`/interview/${id}`);
};

export const updateInterview = (id, data) => {
  return customFetch.put(`/interview/${id}`, data);
};

export const deleteInterview = (id, data) => {
  return customFetch.post(`/interview/delete/${id}`, data);
};

export const addGallery = (data) => {
  return customFetch.post(`/Gallery/add`, data);
};

export const fetchGallery = (page) => {
  return customFetch.get(`/gallery/all/${page}/100`);
};

export const updateGallery = (id, data) => {
  return customFetch.put(`/gallery/${id}`, data);
};

export const deleteGallery = (id, data) => {
  return customFetch.post(`/gallery/delete/${id}`, data);
};

export const addBlog = (data) => {
  return customFetch.post(`/blog/add`, data);
};

export const fetchBlogs = (page) => {
  return customFetch.get(`/blog/all/${page}/9`);
};

export const fetchBlog = (id) => {
  return customFetch.get(`/blog/${id}`);
};

export const updateBlog = (id, data) => {
  return customFetch.put(`/blog/${id}`, data);
};

export const deleteBlog = (id, data) => {
  return customFetch.delete(`/blog/${id}`, data);
};

export const addTag = (data) => {
  return customFetch.post(`/tag/add`, data);
};

export const fetchTags = () => {
  return customFetch.get(`/tag/all`);
};

export const addDirectory = (data) => {
  return customFetch.post(`/directory/add`, data);
};

export const fetchDirectories = (page) => {
  return customFetch.get(`/directory/all/${page}/300`);
};

export const fetchDirectory = (id) => {
  return customFetch.get(`/directory/${id}`);
};

export const updateDirectory = (id, data) => {
  return customFetch.put(`/directory/${id}`, data);
};

export const deleteDirectory = (id, data) => {
  return customFetch.post(`/directory/delete/${id}`, data);
};
